export default [
  { text: 'Tuenti', value: 'tuenti' },
  { text: 'Personal', value: 'personal' },
  { text: 'Movistar', value: 'movistar' },
  { text: 'Claro', value: 'claro' }
]



// WEBPACK FOOTER //
// ./src/data/cellPhoneCompanies.js